export default {"src":"/_next/static/media/icon-2-steps.eb1d2e99.svg","height":28,"width":126,"blurWidth":0,"blurHeight":0};